import styled from "@emotion/styled";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from "@mui/material";
import { Button } from "components/UI";
import { DateField } from "components/UI/InputFields/DateField";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsXSquare } from "react-icons/bs";

const CloseIcon = styled(BsXSquare)`
  color: #ffffff;
  height: 22px;
  width: 22px;
  font-weight: bold;
  margin-left: auto;
  cursor: pointer;
`;

export const FilterLedgerModal = ({ open, onClose, onApply }) => {
  const [startDate, setStartDate] = useState(
    moment().startOf("month").toDate()
  );
  const [endDate, setEndDate] = useState(moment().endOf("month").toDate());

  const { t } = useTranslation();

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle sx={{ bgcolor: "primary.main" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="subtitle1" color="primary.contrastText">
            Filter data by date
          </Typography>
          <CloseIcon
            onClick={() => {
              onClose();
            }}
          />
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={2}>
          <Stack spacing={1}>
            <Typography variant="body2">From</Typography>
            <DateField
              hasNoBg
              value={startDate}
              onChange={value => {
                setStartDate(value);
              }}
            />
          </Stack>
          <Stack spacing={1}>
            <Typography variant="body2">To</Typography>
            <DateField
              hasNoBg
              value={endDate}
              onChange={value => {
                setEndDate(value);
              }}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button flavor="text" onClick={onClose}>
          {t("form.common.cancel")}
        </Button>
        <Button
          onClick={() => {
            onApply({
              startDate: moment(startDate).format("YYYY-MM-DD"),
              endDate: moment(endDate).format("YYYY-MM-DD")
            });
          }}
        >
          Search
        </Button>
      </DialogActions>
    </Dialog>
  );
};
